module.exports = __webpack_public_path__ + "static/United-States-f936360b6f919c0fffb542d5f0d692a6.jpg";